import { useTranslation } from 'react-i18next';
import { usePermissions } from 'app/api/permission-queries';
import { NewDropdown } from 'app/components/ui';
import { useEditorDocument } from 'app/api/documents/useEditorData';
import { useEditorLiveSection } from 'app/state/contexts/EditorUiContext';
import { useEditorSearch } from 'app/router/params';
interface EditorModeProps {
  currentMode: 'tagging' | 'editing';
  onModeChange: (mode: 'tagging' | 'editing') => void;
}

export const EditorModePicker = ({ currentMode, onModeChange }: EditorModeProps) => {
  const { t } = useTranslation('tag');

  const { data: pDocument } = useEditorDocument();
  const section = useEditorLiveSection();
  const { documentPermissions, sectionPermissions } = usePermissions(pDocument?.superId);
  const canComment = sectionPermissions[section?.superId] === 'COMMENT';
  const isTranslation = !!useEditorSearch().translation;

  const hasEditPermission = documentPermissions.includes('TAG_EDITOR') || documentPermissions.includes('TAG_ADMIN');
  const hasViewPermission = documentPermissions.includes('TAG_VIEWER');

  if (isTranslation || (!hasEditPermission && !hasViewPermission)) {
    return null;
  }

  const editingModes = [
    {
      label: t('tagging.mode.label'),
      value: 'tagging',
      icon: <i className="fa-regular fa-lg fa-tag" />,
    },
    canComment
      ? {
          label: t('comment.mode.label'),
          value: 'editing',
          icon: <i className="fa-regular fa-lg fa-message" />,
        }
      : {
          label: t('edit.mode.label'),
          value: 'editing',
          icon: <i className="fa-regular fa-lg fa-pen" />,
        },
  ];

  return <NewDropdown variant="rounded" currentValue={currentMode} options={editingModes} onUpdate={(value) => onModeChange(value as 'tagging' | 'editing')} />;
};
